import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { MenuItemsData, ProfileMenuItems } from "../menu";
import { logoutUser } from "../../../Redux/Reducer/authReducer";
import { clearData } from "../../../Redux/Reducer/appReducer";
import ContactSupportModal from "../../../ContactSupportModal";
import Locations from "../AlertModal/Locations";
import Products from "../AlertModal/Products";
import MenuItem from "./MenuItem";
import styles from "./menuitems.module.scss";
import Tags from "../AlertModal/Tags";

const MenuItems = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openContactModal, setOpenContactModal] = useState(false);
  const [openLocationModal, setOpenLocationModal] = useState(false);
  const [openProductsModal, setOpenProductsModal] = useState(false);
  const [openTagsModal, setOpenTagsModal] = useState(false);

  const currentPath = window.location.pathname;
  const profileInformation = useSelector((state) => state.authReducer);
  const { brands, locations, products } = useSelector(
    (state) => state.appReducer
  );
  const isAdmin = profileInformation?.role === "admin";

  // Filter menu items based on user role
  const filteredMenuItems = MenuItemsData.filter(
    (item) => isAdmin || item.title !== "Seller"
  );

  const handleLogout = () => {
    dispatch(logoutUser());
    dispatch(clearData());
    navigate("/");
  };

  const handleMenuItemClick = (menuItem) => {
    if (menuItem.id === "contact-us") {
      setOpenContactModal(true);
    } else if (menuItem.id === "log-out") {
      handleLogout();
    }
  };

  const renderMenuItem = (menuItem, index) => {
    const isActive =
      currentPath.includes(menuItem.path) ||
      currentPath.split("/")[1]?.includes(menuItem.path.split("/")[1]);

    if (menuItem.title === "Locations" && !isAdmin && brands.length === 0) {
      return (
        <div
          className={styles.menu_items_link}
          key={index}
          onClick={() => setOpenLocationModal(true)}
        >
          <MenuItem
            icon={menuItem.icon}
            title={menuItem.title}
            isActive={isActive}
          />
        </div>
      );
    }

    if (menuItem.title === "Products" && !isAdmin && locations.length === 0) {
      return (
        <div
          className={styles.menu_items_link}
          key={index}
          onClick={() => setOpenProductsModal(true)}
        >
          <MenuItem
            icon={menuItem.icon}
            title={menuItem.title}
            isActive={isActive}
          />
        </div>
      );
    }

    if (menuItem.title === "Tags" && !isAdmin && products.length === 0) {
      return (
        <div
          className={styles.menu_items_link}
          key={index}
          onClick={() => setOpenTagsModal(true)}
        >
          <MenuItem
            icon={menuItem.icon}
            title={menuItem.title}
            isActive={isActive}
          />
        </div>
      );
    }

    return (
      <Link to={menuItem.path} className={styles.menu_items_link} key={index}>
        <MenuItem
          icon={menuItem.icon}
          title={menuItem.title}
          isActive={isActive}
        />
      </Link>
    );
  };

  return (
    <>
      <ContactSupportModal
        openModal={openContactModal}
        toggle={() => setOpenContactModal(false)}
      />
      <Locations
        openModal={openLocationModal}
        toggle={() => setOpenLocationModal(false)}
      />
      <Products
        openModal={openProductsModal}
        toggle={() => setOpenProductsModal(false)}
      />
      <Tags openModal={openTagsModal} toggle={() => setOpenTagsModal(false)} />

      <div className={styles.menu_items_layout}>
        {filteredMenuItems.map((menuItem, index) =>
          renderMenuItem(menuItem, index)
        )}
      </div>

      <div className={styles.logout_contact_container}>
        {ProfileMenuItems.map((menuItem, index) => (
          <MenuItem
            key={index}
            icon={menuItem.icon}
            title={menuItem.title}
            isActive={false}
            onClick={() => handleMenuItemClick(menuItem)}
          />
        ))}
      </div>
    </>
  );
};

export default MenuItems;

// import React, { useState } from "react";
// import { MenuItemsData, ProfileMenuItems } from "../menu";
// import { useDispatch, useSelector } from "react-redux";
// import { Link, useNavigate } from "react-router-dom";
// import styles from "./menuitems.module.scss";
// import MenuItem from "./MenuItem";
// import { logoutUser } from "../../../Redux/Reducer/authReducer";
// import { clearData } from "../../../Redux/Reducer/appReducer";
// import ContactSupportModal from "../../../ContactSupportModal";
// import Locations from "../AlertModal/Locations";
// import Products from "../AlertModal/Products";

// const MenuItems = () => {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [openContactModal, setOpenContactModal] = useState(false);
//   const [openLocationModal, setOpenLocationModal] = useState(false);
//   const [openProductsModal, setOpenProductsModal] = useState(false);
//   const currentPath = window.location.pathname;
//   const profileInformation = useSelector((state) => state.authReducer);
//   const { brands, locations } = useSelector((state) => state.appReducer);
//   const adminRole = profileInformation?.role || "";
//   const isAdmin = adminRole === "admin";
//   const filterredMenuItems = (MenuItemsData || [])?.filter((item) => {
//     if (!isAdmin) {
//       if (item?.title === "Seller") {
//         return false;
//       } else return true;
//     } else {
//       return true;
//     }
//   });
//   const Logout = () => {
//     dispatch(logoutUser());
//     dispatch(clearData());
//     navigate(`/`);
//   };

//   return (
//     <>
//       {openContactModal ? (
//         <ContactSupportModal
//           openModal={openContactModal}
//           toggle={() => setOpenContactModal(false)}
//         />
//       ) : null}
//       {openLocationModal && (
//         <Locations
//           openModal={openLocationModal}
//           toggle={() => setOpenLocationModal(false)}
//         />
//       )}
//       {openProductsModal && (
//         <Products
//           openModal={openProductsModal}
//           toggle={() => setOpenProductsModal(false)}
//         />
//       )}
//       <div className={styles["menu_items_layout"]}>
//         {filterredMenuItems.map((menuItem, index) => {
//           const isActive =
//             currentPath?.includes(menuItem?.path) ||
//             currentPath
//               ?.split("/")?.[1]
//               ?.includes(menuItem?.path?.split("/")?.[1]) ||
//             false;
//           return (
//             <>
//               {/* {menuItem?.title === 'Locations' && } */}

//               {isAdmin ? (
//                 <Link
//                   to={menuItem.path}
//                   className={styles["menu_items_link"]}
//                   key={index}
//                 >
//                   <MenuItem
//                     icon={menuItem.icon}
//                     title={menuItem.title}
//                     isActive={isActive}
//                   />
//                 </Link>
//               ) : (
//                 <>
//                   {menuItem?.title === "Dashboard" && (
//                     <Link
//                       to={menuItem.path}
//                       className={styles["menu_items_link"]}
//                       key={index}
//                     >
//                       <MenuItem
//                         icon={menuItem.icon}
//                         title={menuItem.title}
//                         isActive={isActive}
//                       />
//                     </Link>
//                   )}

//                   {menuItem?.title === "Locations" && (
//                     <>
//                       {brands?.length === 0 ? (
//                         <div
//                           className={styles["menu_items_link"]}
//                           key={index}
//                           onClick={() => setOpenLocationModal(true)}
//                         >
//                           <MenuItem
//                             icon={menuItem.icon}
//                             title={menuItem.title}
//                             isActive={isActive}
//                           />
//                         </div>
//                       ) : (
//                         <Link
//                           to={menuItem.path}
//                           className={styles["menu_items_link"]}
//                           key={index}
//                         >
//                           <MenuItem
//                             icon={menuItem.icon}
//                             title={menuItem.title}
//                             isActive={isActive}
//                           />
//                         </Link>
//                       )}
//                     </>
//                   )}

//                   {menuItem?.title === "Products" && (
//                     <>
//                       {locations?.length === 0 ? (
//                         <div
//                           className={styles["menu_items_link"]}
//                           key={index}
//                           onClick={() => setOpenProductsModal(true)}
//                         >
//                           <MenuItem
//                             icon={menuItem.icon}
//                             title={menuItem.title}
//                             isActive={isActive}
//                           />
//                         </div>
//                       ) : (
//                         <Link
//                           to={menuItem.path}
//                           className={styles["menu_items_link"]}
//                           key={index}
//                         >
//                           <MenuItem
//                             icon={menuItem.icon}
//                             title={menuItem.title}
//                             isActive={isActive}
//                           />
//                         </Link>
//                       )}
//                     </>
//                   )}

//                   {menuItem?.title === "Brands" && (
//                     <Link
//                       to={menuItem.path}
//                       className={styles["menu_items_link"]}
//                       key={index}
//                     >
//                       <MenuItem
//                         icon={menuItem.icon}
//                         title={menuItem.title}
//                         isActive={isActive}
//                       />
//                     </Link>
//                   )}

//                   {menuItem?.title === "Tags" && (
//                     <Link
//                       to={menuItem.path}
//                       className={styles["menu_items_link"]}
//                       key={index}
//                     >
//                       <MenuItem
//                         icon={menuItem.icon}
//                         title={menuItem.title}
//                         isActive={isActive}
//                       />
//                     </Link>
//                   )}
//                 </>
//               )}
//             </>
//           );
//         })}
//       </div>

//       <div className={styles["logout_contact_container"]}>
//         {(ProfileMenuItems || []).map((menuItem, index) => (
//           <MenuItem
//             icon={menuItem?.icon || ""}
//             isActive={false}
//             key={index}
//             title={menuItem?.title || ""}
//             onClick={() => {
//               if (menuItem?.id === "contact-us") {
//                 setOpenContactModal(true);
//               }
//               if (menuItem?.id === "log-out") {
//                 Logout();
//               }
//             }}
//           />
//         ))}
//       </div>
//     </>
//   );
// };

// export default MenuItems;
